import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import { DentalSection, FizioSection } from "@/components/sections/Services";
import About from "@/components/sections/About";
import Reviews from "@/components/sections/Reviews";
import Booking from "@/components/sections/Booking";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import FloatingWhatsApp from "@/components/sections/FloatingWhatsApp";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="min-h-screen bg-white text-slate-900 antialiased">
      <Header />
      <main>
        <Hero />
        <DentalSection />
        <FizioSection />
        <section id="servicii" aria-hidden="true" />
        <About />
        <Reviews />
        <Booking />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
